
import { Link } from 'react-router-dom';

interface FeaturedPostProps {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  views: number;
  image: string;
}

const FeaturedPost = ({ id, title, excerpt, category, date, readTime, image }: FeaturedPostProps) => {
  return (
    <Link
      to={`/dinh-cu-latvia/blog/${id}`}
      className="group block bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 cursor-pointer"
    >
      {/* Mobile nhỏ: layout ngang compact */}
      <div className="flex sm:hidden">
        <div className="relative w-[130px] min-w-[130px] h-[140px] overflow-hidden">
          <img
            src={image}
            alt={`${title} - Tin tức định cư Latvia`}
            title={title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-gold-600 text-white text-[10px] font-semibold rounded flex items-center gap-0.5">
            <i className="ri-star-fill text-[10px]"></i>Nổi bật
          </span>
        </div>
        <div className="flex-1 p-3 flex flex-col justify-center min-w-0">
          <span className="inline-block px-2 py-0.5 bg-gold-50 text-gold-700 text-[10px] font-medium rounded-full mb-1.5 w-fit border border-gold-200">
            {category}
          </span>
          <h2 className="text-[13px] font-bold text-gray-900 mb-1 group-hover:text-gold-700 transition-colors leading-snug font-serif line-clamp-2">
            {title}
          </h2>
          <p className="text-[11px] text-gray-500 leading-relaxed line-clamp-2 mb-1.5">
            {excerpt}
          </p>
          <div className="flex items-center gap-2 text-[10px] text-gray-400">
            <span className="flex items-center gap-0.5">
              <i className="ri-calendar-line"></i>
              {date}
            </span>
            <span className="flex items-center gap-0.5">
              <i className="ri-time-line"></i>
              {readTime}
            </span>
          </div>
        </div>
        <div className="flex items-center pr-3">
          <i className="ri-arrow-right-s-line text-gray-300 text-lg"></i>
        </div>
      </div>

      {/* SM trở lên: layout dọc/grid gốc */}
      <div className="hidden sm:grid grid-cols-1 md:grid-cols-5">
        <div className="relative w-full h-60 md:h-80 md:col-span-3 overflow-hidden">
          <img
            src={image}
            alt={`${title} - Tin tức định cư Latvia`}
            title={title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <span className="absolute top-4 left-4 px-3 py-1 bg-gold-600 text-white text-xs font-semibold rounded-md flex items-center gap-1">
            <i className="ri-star-fill text-xs"></i>Nổi bật
          </span>
        </div>
        <div className="p-6 md:p-8 md:col-span-2 flex flex-col justify-center">
          <span className="inline-block px-3 py-1 bg-gold-50 text-gold-700 text-xs font-medium rounded-full mb-3 w-fit border border-gold-200">
            {category}
          </span>
          <h2 className="text-lg md:text-2xl font-bold text-gray-900 mb-3 md:mb-4 group-hover:text-gold-700 transition-colors leading-snug font-serif line-clamp-3">
            {title}
          </h2>
          <p className="text-sm text-gray-500 mb-4 md:mb-6 leading-relaxed line-clamp-3">
            {excerpt}
          </p>
          <div className="flex items-center gap-3 text-xs text-gray-400">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {readTime}
            </span>
          </div>
          <span className="mt-5 inline-flex items-center text-sm font-semibold text-gold-600 group-hover:text-gold-700 transition-colors">
            Đọc tiếp
            <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
          </span>
        </div>
      </div>
    </Link>
  );
};

export default FeaturedPost;
